module.exports = __webpack_public_path__ + "static/media/campus-catering-with-food-trucks-3.dbc1fd3f.jpeg";